import { Button, Modal, Typography } from "antd";
import styles from "../../deliveryServices/DeliveryServices.module.css";
import { ExclamationCircleFilled } from "@ant-design/icons";

const { Text } = Typography;

export default function GrubhubDialogCancel({
  closeForm,
  handleCloseModal,
  showModal,
}) {
  return (
    <Modal
      centered
      open={showModal}
      onCancel={handleCloseModal}
      footer={[null]}
      closable={false}
    >
      <div style={{ display: "flex", gap: 12 }}>
        <ExclamationCircleFilled
          style={{ color: "#FAAD14", fontSize: 20, marginTop: -20 }}
        />
        <div>
          <Text strong style={{ fontSize: 16 }}>
            Confirm Discard
          </Text>
          <p className={styles.dsFormLabels}>Are you sure you want to discard your changes?</p>
        </div>
      </div>
      <div
        style={{
          marginTop: 24,
          textAlign: "right",
          display: "flex",
          justifyContent: "flex-end",
          gap: 12,
        }}
      >
        <Button onClick={handleCloseModal} style={{ marginRight: 8 }}>
          Keep Editing
        </Button>
        <Button danger onClick={closeForm}>
          Discard
        </Button>
      </div>
    </Modal>
  );
}
